import React from 'react';
import ButtonIcon from '../../../buttons/ButtonIcon';
import Glyphicon from '../../../generic/Glyphicon';
import Table from '../../../Table';
import { useOperator } from './OperatorProvider';

const NavigationOverrideList = () => {
    const { mapElement, onEditNavigation, onDeleteNavigation } = useOperator();

    const columns = [
        {
            renderHeader: () => 'Actions',
            renderCell: ({ rowIndex }) => (
                <span className="nowrap">
                    <ButtonIcon
                        glyph="pencil"
                        title="Edit"
                        onClick={() => onEditNavigation(rowIndex)}
                    />
                    <ButtonIcon
                        className="margin-left-small danger"
                        glyph="trash"
                        title="Delete"
                        onClick={() => onDeleteNavigation(rowIndex)}
                    />
                </span>
            ),
        },
        {
            renderHeader: () => 'Navigation',
            renderCell: ({ item: { navigationElementDeveloperName } }) =>
                navigationElementDeveloperName ?? '',
        },
        {
            renderHeader: () => 'Item',
            renderCell: ({ item: { navigationItemDeveloperName } }) =>
                navigationItemDeveloperName ?? '',
        },
        {
            renderHeader: () => 'Location',
            renderCell: ({ item: { locationMapElementDeveloperName } }) =>
                locationMapElementDeveloperName ?? '',
        },
        {
            renderHeader: () => <span className="block full-width text-center">Enabled</span>,
            renderCell: ({ item: { isEnabled } }) => (
                <span className="block full-width text-center">
                    {isEnabled ? <Glyphicon glyph="ok" /> : <Glyphicon glyph="remove" />}
                </span>
            ),
        },
        {
            renderHeader: () => <span className="block full-width text-center">Visible</span>,
            renderCell: ({ item: { isVisible } }) => (
                <span className="block full-width text-center">
                    {isVisible ? <Glyphicon glyph="ok" /> : <Glyphicon glyph="remove" />}
                </span>
            ),
        },
    ];

    return <Table columns={columns} className="table" items={mapElement.navigationOverrides} testId="navigation-overrides-list" />;
};

export default NavigationOverrideList;
